export const DEFAULT_FACTS = [
    {
        title: 'Mukhi',
        textEn:
            'Mukhi refers to the number of natural clefts (faces) on a Rudraksha bead and guides traditional usage and benefits.',
        textHi:
            'Mukhi ka matlab bead par kitne chehre (faces) hain aur yeh pehchaan aur fayde batata hai.',
    },
    {
        title: 'Kantha',
        textEn:
            'Kantha means a sacred strand or necklace; here it refers to mala design and threading that affect comfort and wearability.',
        textHi:
            'Kantha ka matlab pavitra mala ya haar; yeh mala ki design aur dhaage ko darshata hai.',
    },
    {
        title: 'Siddha Mala',
        textEn:
            'A Siddha Mala is a blessed mala prepared through specific consecration practices.',
        textHi:
            'Siddha Mala ek aisi mala hoti hai jo pavitra vidhi se siddh ki gayi ho.',
    },
    {
        title: 'Wearing Tip',
        textEn:
            'Start with short daily wear and cleanse gently; intent and discipline matter most.',
        textHi:
            'Shuruaat chhoti daily wear se karein, mala ko halke se saaf karein; niyat aur discipline mahatvapurn hain.',
    },
];

export const MINIMIZE_KEY = 'shakti_minimized_v1';
export const QUIZ_STATE_KEY = 'shakti_quiz_state_v1';
export const RECOMMENDATION_KEY = 'shakti_recommendations_v1';
export const USER_PROFILE_KEY = 'shakti_user_profile_v1';

export const TEAMS = ['A', 'S', 'R'];

export const QUIZ_STEPS = {
  WELCOME: 'welcome',
  USER_INFO: 'user_info',
  QUIZ: 'quiz',
  LOADING: 'loading',
  RECOMMENDATIONS: 'recommendations',
  PRODUCT_DETAILS: 'product_details'
};
